import { create } from 'zustand';
import { CreditNote, creditNotesAPI } from '@/utils/creditNotesAPI';

interface CreditNotesState {
  currentCreditNote: CreditNote | null;
  isLoading: boolean;
  error: string | null;
  fetchCreditNote: (id: string) => Promise<void>;
  clearCurrentCreditNote: () => void;
}

export const useCreditNotesStore = create<CreditNotesState>((set) => ({
  currentCreditNote: null,
  isLoading: false,
  error: null,

  fetchCreditNote: async (id: string) => {
    set({ isLoading: true, error: null });
    try {
      const creditNote = await creditNotesAPI.getById(id);
      set({ currentCreditNote: creditNote, isLoading: false });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Erreur inconnue',
        isLoading: false,
      });
    }
  },

  clearCurrentCreditNote: () => {
    set({ currentCreditNote: null, error: null });
  },
}));
